import React, { useEffect } from 'react';
import {
    changeDepartment1All,
    changeDepartment2All,
    changeAddressAll,
    changeSuiteRoomAll,
    changeCityAll,
    changeStateAll,
    changeZipAll,
    changeColorAll,
    getAddressLine1P3T6,
    getAddressLine2P3T6,
} from './../CanvasActions';
import TextField from './../Form/TextField';
import SelectField from './../Form/SelectField';

const FormP3T6 = React.memo((props) => {
    useEffect(() => {
        changeDepartment1All(props.department1);
    }, [props.department1]);

    useEffect(() => {
        changeDepartment2All(props.department2);
    }, [props.department2]);

    useEffect(() => {
        changeAddressAll(props.address);
    }, [props.address]);

    useEffect(() => {
        changeSuiteRoomAll(props.suiteRoom);
    }, [props.suiteRoom]);

    useEffect(() => {
        changeCityAll(props.city);
    }, [props.city]);

    useEffect(() => {
        changeStateAll(props.state);
    }, [props.state]);

    useEffect(() => {
        changeZipAll(props.zip);
    }, [props.zip]);

    useEffect(() => {
        changeColorAll(props.color);
    }, [props.color]);

    const handleSetAddress = (value) => {
        changeAddressAll(value);
        const address = getAddressLine1P3T6();

        if (address.length > 61) {
            props.setAddress(props.address);
            changeAddressAll(props.address);
        } else {
            props.setAddress(value);
        }
    };

    const handleSetSuiteRoom = (value) => {
        changeSuiteRoomAll(value);
        const address = getAddressLine1P3T6();

        if (address.length > 61) {
            props.setSuiteRoom(props.suiteRoom);
            changeSuiteRoomAll(props.suiteRoom);
        } else {
            props.setSuiteRoom(value);
        }
    };

    const handleSetCity = (value) => {
        changeCityAll(value);
        const address = getAddressLine2P3T6();

        if (address.length > 61) {
            props.setCity(props.city);
            changeCityAll(props.city);
        } else {
            props.setCity(value);
        }
    };

    const handleSetZip = (value) => {
        changeZipAll(value);
        const address = getAddressLine2P3T6();

        if (address.length > 61) {
            props.setZip(props.zip);
            changeZipAll(props.zip);
        } else {
            props.setZip(value);
        }
    };

    const renderCount = (value, limit) => {
        let count = 0;
        if (value) {
            count = value.length;
        }

        return <div className="limit-message">{count}/{limit} characters</div>;
    };

    return (
        <form action="">
            <hr />
            <SelectField
                required
                label="Color"
                value={props.color}
                setFunction={props.setColor}
                options={[
                    { value: '1', label: 'Color' },
                    { value: '2', label: 'Black and White' },
                ]}
            />
            <TextField
                required
                label="Clinic/Department 1"
                limit="55"
                showCount
                value={props.department1}
                setFunction={props.setDepartment1}
                placeholder="Clinic or Department Line 1"
            />
            <TextField
                label="Clinic/Department 2"
                limit="55"
                showCount
                value={props.department2}
                setFunction={props.setDepartment2}
                placeholder="Clinic or Department Line 2"
            />
            <hr />
            <TextField
                required
                label="Address"
                value={props.address}
                setFunction={handleSetAddress}
                placeholder="Address"
            />
            <TextField
                label="Suite #"
                value={props.suiteRoom}
                setFunction={handleSetSuiteRoom}
                placeholder="Suite #"
            />
            {renderCount(getAddressLine1P3T6(), 61)}
            <TextField
                required
                label="City"
                value={props.city}
                setFunction={handleSetCity}
            />
            <TextField
                required
                label="Zip"
                value={props.zip}
                setFunction={handleSetZip}
            />
            {renderCount(getAddressLine2P3T6(), 61)}
            <hr />
            <SelectField
                required
                label="Quantity"
                value={props.quantity}
                setFunction={props.setQuantity}
                options={[
                    { value: '', label: 'Select option' },
                    { value: '250', label: '250' },
                    { value: '500', label: '500' },
                    { value: '1000', label: '1000' },
                    { value: '2000', label: '2000' },
                ]}
            />
            <hr />
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> Co-branded No. 10 Window Envelope</div>
                <div className="mt-2">
                    <span className="label">Description:</span> This customizable envelope includes a window to show 
                    the recipient address and fits an 8.5x11” folded letter.
                </div>
                <div className="description-list">
                    <span className="label">Description:</span>
                    <ul>
                        <li>Variable on front</li>
                        <li>9.5x4.125"</li>
                        <li>Window to reveal recipient address</li>
                        <li>One-sided</li>
                        <li>Color or Black and White</li>
                        <li>80# Avalanche Smooth Text</li>
                    </ul>
                </div>
            </div>
        </form>
    );
});

export default FormP3T6;
